import { CVEditingSection, FullCV } from '@cibli/shared';
import React from 'react';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface HobbiesAndInterestsProps {
  hobbiesAndInterests: FullCV['hobbiesAndInterests'];
  onEdit?: (section: CVEditingSection) => void;
  headingColor?: string;
}

const HobbiesAndInterests: React.FC<HobbiesAndInterestsProps> = ({
  hobbiesAndInterests,
  onEdit,
  headingColor,
}) => {
  const { t } = useCVTranslation();

  const handleEdit = () => {
    if (onEdit) {
      onEdit('hobbiesAndInterests');
    }
  };

  const editable = onEdit !== undefined;
  if (!hobbiesAndInterests?.length && !editable) return null;

  return (
    <EditableSection onEdit={handleEdit} editable={editable}>
      <div className="mb-2 p-2 m-2">
        <h2
          className="text-[11px] font-black uppercase tracking-widest pb-1.5 mb-2.5"
          style={{ color: headingColor ?? '#000000' }}
        >
          {t('CV.hobbiesAndInterests')}
        </h2>
        <div className="flex flex-wrap gap-1.5">
          {(hobbiesAndInterests ?? []).map((hobby, index) => (
            <span
              key={index}
              className="text-[11px] text-black bg-primary/10 px-2 py-0.5 rounded leading-relaxed"
            >
              {hobby}
            </span>
          ))}
        </div>
      </div>
    </EditableSection>
  );
};

export default HobbiesAndInterests;
